export interface RoutineSource {
  renderable: boolean;
  video_id: string;
  storage_path: string | null;
  video_url: string | null;
  duration: number;
  revision: string;
}

export interface RoutineClip {
  renderable?: boolean;
  entry_id: string;
  course_id: string;
  name: string;
  video_id: string | null;
  source_revision: string | null;
  storage_path: string | null;
  video_url: string | null;
  start: number | null;
  end: number | null;
  duration: number | null;
  reviewed: boolean;
}

export interface RoutineVideoChoice {
  video_type: string | null;
  id: string;
  course_id: string;
  title: string;
  video_url: string | null;
  source: RoutineSource | null;
}

export interface RoutineSnapshot {
  playlist_id: string;
  name: string;
  fingerprint: string;
  clips: RoutineClip[];
  ready: boolean;
  can_edit?: boolean;
  has_generated?: boolean;
  current: boolean;
  job: {
    phase?: string;
    id: string | null;
    fingerprint: string;
    active: boolean;
    error: string | null;
  } | null;
  playback: {
    provider?: "supabase" | "vimeo";
    path: string;
    url: string;
    expires_at: number;
    current: boolean;
  } | null;
  videos?: RoutineVideoChoice[];
}

export interface RoutineJob {
  provider?: "supabase" | "vimeo";
  id: string;
  fingerprint: string;
  path: string;
  clips: RoutineClip[];
}

export interface RoutineReview {
  entry_id: string;
  video_id: string;
  source_revision: string;
  start: number;
  end: number;
}

export type RoutineProgress = { stage: string; percent?: number };

export function validateTrim(
  start: number,
  end: number,
  duration: number,
): string | null {
  if (![start, end, duration].every(Number.isFinite))
    return "Enter valid start and end times.";
  if (start < 0 || end <= start) return "End time must be after start time.";
  if (duration <= 0 || end > duration + 0.001)
    return "The selection must fit inside the video.";
  return null;
}

export function formatTimestamp(seconds: number): string {
  const milliseconds = Math.round(seconds * 1000);
  return `${Math.floor(milliseconds / 60000)
    .toString()
    .padStart(
      2,
      "0",
    )}:${((milliseconds % 60000) / 1000).toFixed(3).padStart(6, "0")}`;
}

export function parseTimestamp(value: string): number {
  if (!/^\d+:\d{2}(\.\d{1,3})?$/.test(value)) return NaN;
  const [minutes, seconds] = value.split(":").map(Number);
  return seconds! < 60 ? minutes! * 60 + seconds! : NaN;
}
